import { useQuery } from "@tanstack/react-query";
import { departmentService } from "@/features/departments/services/departmentService";
import { queryKeys } from "@/lib/query-keys";
import type { ListDepartmentsQuery } from "@/types/department";

export function useDepartments(filters?: ListDepartmentsQuery) {
  return useQuery({
    queryKey: queryKeys.departments.list(filters),
    queryFn: () => departmentService.list(filters),
  });
}

export function useDepartmentTree() {
  return useQuery({
    queryKey: queryKeys.departments.tree(),
    queryFn: () => departmentService.tree(),
  });
}

export function useDepartment(id: string) {
  return useQuery({
    queryKey: queryKeys.departments.detail(id),
    queryFn: () => departmentService.get(id),
    enabled: !!id,
  });
}
